import React from 'react';

export const LoanSummaryContext = React.createContext();
export const AppDisplayContext = React.createContext();
// export default LoanSummaryContext;
// export const LoanFromBankContext = createContext();
